import React from 'react'

type accountButton = {
  selected: boolean
  label: string
  onClick?: () => void
}

export const AccountButton = ({
  selected = false,
  label,
  onClick,
}: accountButton) => (
  <button
    className={`!px-3 py-1 text-xs md:text-base font-medium rounded-md
            ${selected ? 'bg-[#0C5F71] text-white' : 'bg-white text-[#37A2BA]'}
        `}
    onClick={onClick}
  >
    {label}
  </button>
)
